export default __webpack_public_path__ + "static/CircularStd-Medium-b547df3f894204b692a0a6d44e6fda43.ttf";